import React from 'react';


const LoadingComponent = () => null;

export default LoadingComponent;
